// extracted by mini-css-extract-plugin
export default {"container":"Breadcrumb_container__hLGVR","item":"Breadcrumb_item__04R-n","separator":"Breadcrumb_separator__gdwIm","active":"Breadcrumb_active__WrY3T"};